import userInfo from './userInfo';
import goodnightUserInfo from './goodnightUserinfo';

export default {
	userInfo,
	goodnightUserInfo
};



// WEBPACK FOOTER //
// ./src/redux/reducers/reading/index.js